import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OurTeamDetailsComponent } from './our-team-details.component';
const routes: Routes = [
  {
    path: '',
    component: OurTeamDetailsComponent
  }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OurTeamDetailsRoutingoModule { }